<p-fieldset legend="Comissão de Licitação">
  <div class="row">
    <label class="required col-3 col-form-label">
      Existe Comissão de Licitação?
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3" [(ngModel)]="entidade.ComissaoLicitacaoNao"
      [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>

  <lib-licitacao-audesp-comissao-membro [comissao]="entidade.ComissaoLicitacao"
    *ngIf="entidade.ComissaoLicitacaoNao === 'S'"></lib-licitacao-audesp-comissao-membro>

  <p-fieldset legend="Audiência pública" *ngIf="entidade.ComissaoLicitacaoNao === 'S'">
    <div class="row">
      <label class="required col-3 col-form-label">
        Tipo da Comissão?
      </label>
      <select [compareWith]="compareFn" class="form-control col-3"
        [(ngModel)]="entidade.ComissaoLicitacao.TipoComissaoLicitacao" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let item of opcoesTipoComissao" [ngValue]="item.id">{{item.nome}}</option>
      </select>
    </div>
  </p-fieldset>

  <lib-licitacao-audesp-comissao-designacao [comissao]="entidade.ComissaoLicitacao"
    *ngIf="entidade.ComissaoLicitacaoNao === 'S'"></lib-licitacao-audesp-comissao-designacao>

  <p-fieldset legend="Data de Publicação do Ato de Designação da Comissão de Licitação"
    *ngIf="entidade.ComissaoLicitacaoNao === 'S'">
    <div class="row">
      <label class="required col-3 col-form-label">
        Houve publicação do Ato de Designação da Comissão de Licitação?
      </label>
      <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3"
        [(ngModel)]="entidade.ComissaoLicitacao.atoDesignacaoComissaoNao" [ngModelOptions]="{standalone: true}">
        <ng-template let-opcao>
          <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
        </ng-template>
      </p-selectButton>
      <label class="required col-3 col-form-label" *ngIf="entidade.ComissaoLicitacao.atoDesignacaoComissaoNao === 'S'">
        Data da publicação
      </label>
      <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="entidade.ComissaoLicitacao.AtoDesignacaoComissaoDt"
        [ngModelOptions]="{standalone: true}" (onFocus)="globalService.calendarMascara()"
        *ngIf="entidade.ComissaoLicitacao.atoDesignacaoComissaoNao === 'S'" inputStyleClass=" form-control col-auto"
        dataType="string" dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
      </p-calendar>
    </div>
  </p-fieldset>

  <p-fieldset legend="Vigência do Ato de Designação da Comissão de Licitação"
    *ngIf="entidade.ComissaoLicitacaoNao === 'S'">
    <div class="row">
      <label class="required col-3 col-form-label">
        Data Início Vigência
      </label>
      <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="entidade.ComissaoLicitacao.AtoDesignacaoComissaoInicio"
        [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
        dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
      </p-calendar>
      <label class="required col-3 col-form-label">
        Data Final Vigência
      </label>
      <p-calendar (onFocus)="onFocusDate()" [(ngModel)]="entidade.ComissaoLicitacao.AtoDesignacaoComissaoFim"
        [ngModelOptions]="{standalone: true}" inputStyleClass="form-control col-auto" dataType="string"
        dateFormat="dd/mm/yy" [showOnFocus]="true" [showButtonBar]="true" [showIcon]="true">
      </p-calendar>
    </div>
  </p-fieldset>
</p-fieldset>